<template>
  <span><template v-for="(segment, index) in segments"><strong v-if="segment.bold" :key="index">{{ segment.text }}</strong><span v-else :key="index">{{ segment.text }}</span></template></span>
</template>

<script>
// Doc text with **bold** markers, rendered without v-html.
export default {
  name: 'DocText',
  props: {
    text: { type: String, required: true }
  },
  computed: {
    segments() {
      return this.text
        .split(/(\*\*[^*]+\*\*)/)
        .filter(part => part !== '')
        .map(part => (part.startsWith('**') ? { bold: true, text: part.slice(2, -2) } : { bold: false, text: part }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Docs/DocText.vue